import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {
    createMetSelectWrapper,
    MetSelectInput,
    MetSelectList,
} from '../../../general/components/MetSelectWrapper';

import {changeStartHour} from '../../actionCreators';
import {getStartHour} from '../../selectors';

import StartHourItem from './StartHourItem';

const OptGroupLabel = gettext('Start Hour');

const StartHourSelect = ({startHours, startHour, label, onChange, ...props}) => (
    <div className="met-select-wrapper right-menu-icon">
        <select className="met-select" value={startHour} onChange={onChange}>
            <optgroup label={OptGroupLabel}>
                {startHours.map(({label, ...startHour}) => <option {...startHour}>{label}</option>)}
            </optgroup>
        </select>
        <div className="styled-dropdown">
            <MetSelectInput {...props} value={label} />
            <MetSelectList>
                {startHours.map(startHour => <StartHourItem {...startHour} />)}
            </MetSelectList>
        </div>
    </div>
);

const StartHourSelectWrapper = createMetSelectWrapper(StartHourSelect);

const mapStateToProps = state => {
    const {startHour, startHours} = state;
    const {label} = getStartHour(state);

    return {
        label,
        startHour,
        startHours,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(changeStartHour(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StartHourSelectWrapper);
